import { render, staticRenderFns } from "./textToast.vue?vue&type=template&id=b0ba19e2&scoped=true&"
import script from "./textToast.vue?vue&type=script&lang=js&"
export * from "./textToast.vue?vue&type=script&lang=js&"
import style0 from "./textToast.vue?vue&type=style&index=0&id=b0ba19e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ba19e2",
  null
  
)

export default component.exports